import { Suspense, lazy } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { AuthGuard } from 'src/auth/guard';
// layouts
import DashboardLayout from 'src/layouts/dashboard';
// components
import { LoadingScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

// const IndexPage = lazy(() => import('src/pages/campaign'));
const QuestionBanksAndSurveysPage = lazy(() =>
  import('src/pages/manager/question-banks-and-surveys')
);
const QuestionBankCreatePage = lazy(() => import('src/pages/manager/question-bank-create'));
const QuestionBankEditPage = lazy(() => import('src/pages/manager/question-bank-edit'));
const QuestionBanksAndSurveysResultsPage = lazy(() =>
  import('src/pages/manager/question-banks-and-surveys-results')
);
const MessageTemplatesPage = lazy(() => import('src/sections/manager/message-templates'));
const MessageTemplateCreatePage = lazy(() =>
  import('src/sections/manager/message-templates/message-template-create-edit')
);

// ----------------------------------------------------------------------

export const questionBankRoutes = [
  {
    path: '/',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      {
        path: 'question-banks-and-surveys/',
        element: <QuestionBanksAndSurveysPage />,
      },
      {
        path: 'question-bank/create',
        element: <QuestionBankCreatePage />,
      },
      {
        path: 'question-bank/:questionBankId/edit',
        element: <QuestionBankEditPage />,
      },
      {
        path: 'question-banks-and-surveys/results',
        element: <QuestionBanksAndSurveysResultsPage />,
      },
      {
        path: 'more/message-templates/',
        element: <MessageTemplatesPage />,
      },
      {
        path: 'more/message-templates/create',
        element: <MessageTemplateCreatePage />,
      },
      {
        path: 'more/message-templates/:templateId/edit',
        element: <MessageTemplateCreatePage />,
      },
    ],
  },
];
